const EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

// Gantt layout: the gridlines fade in, then the bars slide in from the left one after another, following the
// timeline. Without JS or with reduced motion the bars are simply shown.
export default (block) => {
  const list = block.querySelector('.steps-block-items');

  if (!list || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    return;
  }

  list.classList.add('is-pending');

  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) {
      return;
    }

    observer.disconnect();
    list.classList.remove('is-pending');
    [...list.children].forEach((item, i) => item.animate({
      opacity: [0, 1],
      transform: ['translateX(-2rem)', 'none']
    }, {
      duration: 1000,
      delay: 200 + (i * 160),
      easing: EASE,
      fill: 'backwards'
    }));
  }, {
    rootMargin: '0px 0px -15% 0px',
    threshold: 0.2
  });

  observer.observe(list);
};
